import type { PropsWithChildren } from 'react';

export function DrawerBody({ children }: PropsWithChildren) {
  return <div className="overflow-y-auto px-md">{children}</div>;
}
DrawerBody.displayName = 'DrawerBody';
